import React, { PropTypes } from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import ProductSpecs from './ProductSpecs'
import ProductApplications from './ProductApplications'
import ProductsGrid from '../ProductsGrid'
import CenterRow from '../CenterRow'
import CTAButton from '../CTAButton'
import AppsAndService from '../AppsAndService'
import ProductSchema from '../SchemaJson/Product'
import LeadForm from '../LeadForm'

import './style.less'

function Product({ data, pages, page }) {

	const meta = {
		description: `${data.Specifications.Model} Specs: ${data.Specifications['Fundamental Freq']}, ${data.Specifications['Output Power']}, ${data.Specifications['Weight']}, ${data.Specifications['Length']}`,
		keywords: "Acoustic Cleaning Systems",
		headline: `ACS Model: ${data.Specifications.Model}`,
		title: `ACS Model: ${data.Specifications.Model}`
	}

	const productPages = pages.filter((page) => {
		return page.path.split('/').indexOf('products') > -1 && 'Specifications' in page.data
	}).sort((a, b) => {
		const { data: { Specifications: { Model:aModel } } } = a
		const { data: { Specifications: { Model:bModel } } } = b
		return aModel.toLowerCase().localeCompare(bModel.toLowerCase());
	});

	const description = `The ${data.Specifications.Model} acoustic cleaner from ACS uses
	compressed air to flex a titanium diaphragm to produce pressure pulses
	that are amplified by the bell.  The resulting low-frequency high-energy
	sound waves that are emitted resonate and dislodge particulate
	deposits. The displaced particulate deposits are then removed
	by gravity and/or gas flow.`

	return (
		<div>
			<Helmet
				title={`${meta.title}`}
				meta={[
					{ name: "Description", content: `${meta.description}`},
					{ name: "Keywords", content: `${meta.keywords}`},
					{ property: "og:title", content: `${meta.headline}`},
					{ property: "og:description", content: `${meta.description}`},
					{ property: "og:type", content: "article"},
					{ property: "og:url", content: `${config.rootUrl}${page.path}`},
					{ name: "twitter:card", content: "summary_large_image"},
					{ name: "twitter:site", content: `${config.twitterHandle}` },
					{ name: "twitter:creator", content: `${config.twitterHandle}` },
					{ name: "twitter:title", content: `${meta.title}` },
					{ name: "twitter:description", content: `${meta.description}` }
				]}
			/>
			<ProductSchema
				name={data.Specifications.Model}
				description={description}
				imagePath={data.Image}
				url={page.path}
			/>
		<div className="container page product">
			<div className="row center-xs">
				<div className="col-xs-12">
					<h1>{data.Specifications.Model}</h1>
					<h2>Sonic Horn</h2>
					<img src={data.Image} />
				</div>
			</div>
			<div className="row center-xs">
				<div className="col-xs-12 col-sm-6 col-md-4">
					<div className="left-col">
						<p>{description}</p>
						<h3>Advantages of {data.Specifications.Model} Model</h3>
						<ul>
							<li>Low Initial Investment</li>
							<li>Easy Installation</li>
							<li>Low Installation Cost</li>
							<li>Low Maintenance Cost</li>
							<li>Low Operational Cost</li>
							<li>No Structural Damage</li>
							<li>No Mechanical Wear on Equipment Surfaces</li>
							<li>No Corrosion or Blockage</li>
							<li>Cleaning of Inaccessible Parts</li>
							<li>Continuous Plant Operation</li>
							<li>Design & Installation Expertise from the ACS Professionals</li>
						</ul>

						<LeadForm
							ctaVariation="secondary"
							ctaLabel={(
								<span style={{ fontWeight: 300, lineHeight: 1.3 }}>
									I'm interested in the <b>{data.Specifications.Model}</b> horn
								</span>
							)}
							product={data.Specifications.Model}
						/>

						<p>
							<img className="icon" width="26" height="26" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAA/klEQVRIS+2W4Q2CMBCFPyZQN9ENHMEN1Al0A3EDmUAdxQnUTWQCzSNtQgxwB030D/erCa/92ld6dxl2TIEDsAE0rscLuABHQOPWyGwOJ2Bn6ApgnwrSTicGSJpZKujtOLUkne54rBtBjU6P1g3+g/9mndLM2fluLNk2pKdK13Qi5a61tYrx/QnM65o261Jggiy/k2zXHQ2BNULM/BQ89tp4A1Zt5cLz13lOdg31KqkeaXIXzIR4rKvvsAnmgkRQLAN9bfRCqvW1eB+Q5sSSrRLvicEgz+J1ze9BsflYAI++2zX0SkN3oNQdedqpVH4hkJrCPDw4q63qCyzDG8w/pjQ2p+sw0pwAAAAASUVORK5CYII=" />
							<a target="_blank" className="plain-link" href={data.Pdf}>Download the PDF product sheet</a>
						</p>
						<p>
							<img className="icon" width="26" height="26" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABNklEQVRIS92U0VECQRAFmwg0AyECDQEiECLQEDQCIQIwAs1AMkAyIAMJgRCstm6tc+uWvYJlP5yfK65u6Jk3b2ZApRhU4tAHdA18AENgdGphOdAdsAGEGbnvk3UcS3wE3qLMoiCrXwKC4igGcg7OQ8m6ogho3EDCPLpAn9FLfx+ALbA7ZpRQ4Rx4OdVRTZ7ANbAA9l2avwMPZ0Li9BXw3H5pR5cAyVDKSSPt7148NU4r3BjOUNifBdQManxVmObM5rFdtbew2572tjhd6nMK3HTkaYxRai9Sc8vtkYVqhPsIOMudIJPaUuZA4f+9Ku3cRS7RC6GUQZLc9+1GlNODbLz2SXQGSqksqdOU8k8YwbYP6BwTWtyXJ+rSoLC4uxogTXGoAfJgV+nI87au0ZGG2P8r0M96fAOuxi2LE1us4QAAAABJRU5ErkJggg==" />
							<a className="plain-link" href="/products/">Show me all the ACS horn models</a>
						</p>

					</div>
				</div>
				<div className="col-xs-12 col-sm-6 col-md-4">
					<ProductSpecs data={data} />
					<ProductApplications />
				</div>
			</div>
		</div>
		<br />
		<br />
		<ProductsGrid caption="Other Sonic Horn Models" pages={productPages} />
		<div className="container">
			<AppsAndService />
		</div>
	</div>
	)
}

Product.propTypes = {
	data: PropTypes.object.isRequired
}

export default Product



// WEBPACK FOOTER //
// ../components/Product/index.js